import { render } from "./GenereratePage.vue?vue&type=template&id=abf5f41a"
import script from "./GenereratePage.vue?vue&type=script&lang=js"
export * from "./GenereratePage.vue?vue&type=script&lang=js"

import "./GenereratePage.vue?vue&type=style&index=0&id=abf5f41a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__